// apps/web/src/screens/auth-callback/auth-callback.screen.tsx
//
// OAuth Code + PKCE callback. The scaffold ships a thin placeholder that
// reads `?code=` and `?error=` and routes accordingly. The full code
// exchange against Cognito's `/oauth2/token` endpoint lands when the
// first ticket wires real PKCE flow.

import { useEffect, useState } from 'react';
import type { JSX } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function AuthCallbackScreen(): JSX.Element {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const oauthError = params.get('error');
    const code = params.get('code');
    if (oauthError) {
      setError(`Google sign-in failed: ${oauthError}`);
      return;
    }
    if (!code) {
      navigate('/login', { replace: true });
      return;
    }
    setError(
      'Google sign-in is not fully configured. Use the email + password form for now.',
    );
  }, [navigate, params]);

  return (
    <main className="mx-auto flex min-h-svh max-w-md flex-col justify-center gap-4 px-4 py-10">
      <h1 className="text-xl font-semibold">Completing sign-in...</h1>
      {error && (
        <p className="text-sm text-red-700" role="alert">
          {error}
        </p>
      )}
    </main>
  );
}
